import {InsightsThemeTokens} from './insightsTheme';

export function getApexTooltipOptions() {
  return {
    theme: 'dark',
    fillSeriesColor: false,
    style: {
      fontSize: '12px',
    },
    x: {
      format: 'dd MMM yyyy',
    },
  };
}

export function mergeApexTooltipOptions(
  _theme: InsightsThemeTokens,
  existing: Record<string, unknown> = {}
) {
  const base = getApexTooltipOptions();
  return {
    ...base,
    ...existing,
    style: {
      ...base.style,
      ...(existing.style as object),
    },
    x: {
      ...base.x,
      ...(existing.x as object),
    },
  };
}
